<template>
  <InstitucionalPageTemplate :loading="loading" :item="item" />
</template>

<script>
import InstitucionalPageTemplate from "../components/templates/InstitucionalPageTemplate.vue";

const _config = {
  mod: "services",
};

export default {
  data: () => ({
    loading: true,
    item: {},
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;
        })
        .then(() => (this.loading = false))
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    InstitucionalPageTemplate,
  },
};
</script>
